import * as React from "react";

function LockSvg(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 8.333V6.666c0-2.758.833-5 5-5s5 2.242 5 5v1.667M10 15.417a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167z"
        stroke="#292929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.167 18.334H5.834c-3.334 0-4.167-.834-4.167-4.167V12.5c0-3.333.833-4.166 4.167-4.166h8.333c3.333 0 4.167.833 4.167 4.166v1.667c0 3.333-.834 4.167-4.167 4.167z"
        stroke="#292929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LockSvg;
